var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M719.8 651.8m-10 0a10 10 0 1 0 20 0 10 10 0 1 0-20 0Z",
    fill: "#E73B37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512.1 64H172v896h680V385.6L512.1 64z m278.8 324.3h-280v-265l280 265zM808 916H216V108h278.6l0.2 0.2v296.2h312.9l0.2 0.2V916z",
    fill: "#39393A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.5 530h325.9v16H280.5z",
    fill: "#39393A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M639.5 530h90.2v16h-90.2z",
    fill: "#E73B37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M403.5 641.8h277v16h-277z",
    fill: "#39393A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M280.6 641.8h91.2v16h-91.2z",
    fill: "#E73B37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M279.9 753.7h326.5v16H279.9z",
    fill: "#39393A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M655.8 753.7h73.9v16h-73.9z",
    fill: "#E73B37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.ab4c01006bcd75a8e68ea8d6895073e2.svg";
export { ForwardRef as ReactComponent };